import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "@/app/config/navigation";
import React from "react";

function SocialMedia() {
  return (
    <div className="flex gap-14  mb-[30px] lg:mb-12 items-center lg:justify-end">
      {socialMedia.map((media, index) => (
        <Link 
          key={index} 
          href={media?.link}
          aria-label={media?.ariaLabel}
        >
          <FontAwesomeIcon
            icon={media?.icon}
            color="#fff"
            size="3x"
            className="text-3xl lg:w-[1.7rem] lg:!h-[1.7rem] w-[20px] !h-[20px]"
          />
        </Link>
      ))}
    </div>
  );
}

export default SocialMedia;
const socialMedia = [
  {
    icon: faInstagram,
    link: "https://www.instagram.com/minicodeleader/",
    ariaLabel: "Visit our Instagram profile",
  },
  {
    icon: faTwitter,
    link: "https://twitter.com/minicodeleaders",
    ariaLabel: "Visit our Twitter profile",
  },
  {
    icon: faFacebookF,
    link: "https://www.facebook.com/profile.php?id=61556783909675",
    ariaLabel: "Visit our Facebook page",
  },
  {
    icon: faLinkedinIn,
    link: "https://www.linkedin.com/company/minicodeleader/about/?viewAsMember=true",
    ariaLabel: "Visit our LinkedIn company page",
  },
  {
    icon: faYoutube,
    link: "https://www.youtube.com/channel/UCklMdXYZaHkoDWZdVk6GQeQ",
    ariaLabel: "Visit our YouTube channel",
  },
];
